<template>
  <div class="buttons-wrapper d-flex align-items-center justify-content-end col-12 col-xl-6 flex-wrap" :class="showStopAutoBookBtn ? 'with-autobook' : ''">
    <div class="d-flex align-items-center flex-column mr-3" v-if="showSaveBtn && !updateInProgress">
      <button
        class="action-button btn-custom btn-custom-invoice"
        @click.prevent="invoice"
      >
        <span class="text-uppercase">{{ $t("general.invoice") }}</span>
      </button>
      <span @click.prevent="printTickets" class="action-spans text-uppercase">{{
        $t("reservation.invoice.send-invoice-documents")
      }}</span>
    </div>
    <div class="d-flex align-items-center flex-column mr-3" :class="showStopAutoBookBtn ? 'mr-3' : ''" v-if="showSaveBtn && !updateInProgress">
      <button
        class="action-button btn-custom btn-custom-send"
        @click.prevent="save"
      >
        <span class="text-uppercase">{{ $t("general.save") }}</span>
      </button>
      <span @click.prevent="saveAndClose" class="action-spans text-uppercase">{{
        $t("reservation.save-and-close")
      }}</span>
    </div>
    <div class="d-flex align-items-center flex-column" v-if="showStopAutoBookBtn && !updateInProgress">
      <button
        class="action-button btn-custom btn-custom-send"
        @click="stopAutobooking"
      >
        <span class="text-uppercase">{{ $t("reservation.stop-autobooking") }}</span>
      </button>
      <span class="text-uppercase action-spans no-clickable">({{autoBookingStatus}})</span>
    </div>
    <div class="d-flex align-items-center flex-column" v-if="showMakeAutobookableBtn && !updateInProgress">
      <button
        class="action-button btn-custom btn-custom-send"
        @click="makeAutobookable"
      >
        <span class="text-uppercase">{{ $t("reservation.plan-autobooking") }}</span>
      </button>
      <span class="text-uppercase action-spans no-clickable">&nbsp;</span>
    </div>
    <div class="col-6 d-flex align-items-center flex-column" v-if="updateInProgress">
      <img src="@/assets/svg/refresh-ccw.svg" alt="loading" class="rotating save-loader">
    </div>
    <div class="close-holder">
      <router-link :to="{ path: closeLink }">
        <button type="button" class="close">&nbsp;</button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeLink: {
      default: '/',
      type: String,
      required: false
    },
    showSaveBtn: {
      default: true,
      type: Boolean,
      required: false
    },
    updateInProgress: {
      default: false,
      type: Boolean,
      required: false
    },
    showStopAutoBookBtn: {
      default: false,
      type: Boolean,
      required: false
    },
    showMakeAutobookableBtn: {
      default: false,
      type: Boolean,
      required: false
    },
    autoBookingStatus: {
      default: '',
      type: String,
      required: false
    }
  },
  data () {
    return {}
  },
  methods: {
    save () {
      this.$emit('save')
    },
    done () {
      this.$emit('done')
    },
    invoice () {
      this.$emit('invoice')
    },
    printTickets () {
      this.$emit('printTickets')
    },
    saveAndClose () {
      this.$emit('saveAndClose')
    },
    stopAutobooking () {
      this.$emit('stopAutobooking')
    },
    makeAutobookable () {
      this.$emit('makeAutobookable')
    }
  }
}
</script>
<style scoped>
.close-holder {
  position: absolute;
  right: 0px;
  top: -8px;
}

.action-button {
  width: 230px;
}

.with-autobook {
  .action-button {
    width: 210px;
  }
}

.action-spans {
  font-family: "Open Sans Bold";
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 0.05em;
  color: #008cdd;
  margin: 8px 0;
}

.action-spans:hover {
  cursor: pointer;
  text-decoration: underline;
}

.action-spans.no-clickable:hover {
  cursor: default;
  text-decoration: none;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.rotating{
  animation: rotation 2s infinite linear;
}
.save-loader {
  position: relative;
  top: -5px;
}
.buttons-wrapper .btn-custom > span{
  font-size: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/core/ReservationTopModalButtons.vue